import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id BA597840-6D3A-4D89-B8DC-63C5B2DA6638
 * name traffic-cone
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/traffic-cone.svg
 * tags
 * - Transportation + Road 
 */
export const TrafficConeIcon = createSvgIcon(<><path d="M17 15L18 19H21V22H3V19H6L7 15H17M15 8L16 12H8L9 8H15M13 1L14 5H10L11 1H13Z" /></>, 'TrafficConeIcon');
export default TrafficConeIcon